const ADDRESS_COMPONENTS = {
    subpremise : 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'both',
    postal_code: 'short_name'
};
const CITIES_TYPE  = ['locality', 'administrative_area_level_3'];
const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2'];

let google_maps_script_loaded = false;


Vue.component('checkout-address-google-autocomplete', {


    props: {
        id: {
            type: String,
            required: true
        },
        types: {
            type: String,
            default: 'address'
        },
        country: {
            type: [String, Array],
            default: null
        },
        enableGeolocation: {
            type: Boolean,
            default: false
        },
        geolocationOptions: {
            type: Object,
            default: null
        },
        template: {
            type: String
        },
        placeholder: {
            type: String
        },
        label: {
            type: String
        }
    },


    data() {
        return {
            /**
             * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
             */
            autocomplete: null,
            autocompleteText: '',
            geolocation: {
                /**
                 * Google Geocoder Object
                 * @type {Geocoder}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                 */
                geocoder: null,
                /**
                 * Filled after geolocate result
                 * @type {Coordinates}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                 */
                loc: null,
                /**
                 * Filled after geolocate result
                 * @type {Position}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                 */
                position: null
            },
            api: {
                domain: 'https://maps.googleapis.com/maps/api/js',
                key: App.napoConfig.addresses.googleMapsAPIKey,
                libraries: 'places'
            }
        }
    },


    watch: {
        autocompleteText: function (newVal, oldVal) {
            this.$emit('inputChange', { newVal, oldVal }, this.id);
        },
        country: function(newVal, oldVal) {
            this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
            });
        }
    },


    mounted: function() {

        window.onload = this.loadScript(
            this.api.domain + '?key=' + this.api.key + '&libraries=' + this.api.libraries,
            this.bindAutocomplete
        );

    },


    created() {
        this.$options.template = this.template;
    },


    methods: {


        loadScript: function(src, callback) {

            let script = document.createElement('script');
            script.id  = 'id--google-maps__script';

            if($('#id--google-maps__script').length === 0) {

                document.body.appendChild(script);

                if (callback) {
                    script.onload = callback;
                }

                script.src = src;

            }else{

                //if script already exists
                //global variable is set to true on first callback
                if(!google_maps_script_loaded) {

                    let interval;
                    let that = this;

                    interval = setInterval(function () {
                        if(google_maps_script_loaded) {
                            that.bindAutocomplete();
                            clearInterval(interval);
                        }
                    }, 100);

                }else{
                    this.bindAutocomplete();
                }
            }
        },

        bindAutocomplete: function () {

            const options = {};

            google_maps_script_loaded = true;

            if (this.types) {
                options.types = [this.types];
            }

            if (this.country) {
                options.componentRestrictions = {
                    country: this.country
                };
            }

            this.autocomplete = new google.maps.places.Autocomplete(
                document.getElementById(this.id),
                options
            );

            this.autocomplete.addListener('place_changed', this.onPlaceChanged);
        },

        onPlaceChanged() {

            let place = this.autocomplete.getPlace();

            if (!place.geometry) {
                this.$emit('no-results-found', place, this.id);
                return;
            }

            if (place.address_components !== undefined) {
                this.autocompleteText = document.getElementById(this.id).value;
                this.$emit('placechanged', this.formatResult(place));
                this.$emit('placechangedstring', {
                        'city': this.formatResult(place),
                        'string': this.autocompleteText
                    }
                );
                //this.autocompleteText = '';
            }
        },

        onFocus() {
            this.biasAutocompleteLocation();
        },

        clear() {
            this.autocompleteText = ''
        },

        update (value) {
            this.autocompleteText = value
        },

        updateCoordinates (value) {

            if (!value && !(value.lat || value.lng)) {
                return;
            }
            if (!this.geolocation.geocoder) {
                this.geolocation.geocoder = new google.maps.Geocoder();
            }

            this.geolocation.geocoder.geocode({'location': value}, (results, status) => {
                if (status === 'OK') {

                    results = this.filterGeocodeResultTypes(results);

                    if (results[0]) {
                        this.$emit('placechanged', this.formatResult(results[0]), results[0], this.id);
                        this.update(results[0].formatted_address);
                    } else {
                        this.$emit('error', 'no result for provided coordinates');
                    }
                } else {
                    this.$emit('error', 'error getting address from coords');
                }
            })
        },

        geolocate () {
            this.updateGeolocation ((geolocation, position) => {
                this.updateCoordinates(geolocation)
            })
        },

        updateGeolocation (callback = null) {

            if (navigator.geolocation) {

                let options = {};

                if(this.geolocationOptions) {
                    Object.assign(options, this.geolocationOptions);
                }

                navigator.geolocation.getCurrentPosition(position => {

                    let geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    this.geolocation.loc      = geolocation;
                    this.geolocation.position = position;

                    if (callback) {
                        callback(geolocation, position);
                    }
                }, err => {
                    this.$emit('error', 'Cannot get Coordinates from navigator', err);
                }, options);
            }
        },

        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        biasAutocompleteLocation () {

            if (this.enableGeolocation) {

                this.updateGeolocation((geolocation, position) => {

                    let circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });

                    this.autocomplete.setBounds(circle.getBounds());
                })
            }
        },

        formatResult (place) {

            let returnData = {};

            for (let i = 0; i < place.address_components.length; i++) {

                let addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {

                    if(ADDRESS_COMPONENTS[addressType] === 'both') {
                        returnData[addressType] = {
                            'name': place.address_components[i]['long_name'],
                            'iso': place.address_components[i]['short_name']
                        };
                    }else{
                        returnData[addressType] = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    }
                }
            }

            returnData['latitude']  = place.geometry.location.lat();
            returnData['longitude'] = place.geometry.location.lng();

            return {
                'town'         : returnData.locality,
                'address1'     : returnData.route,
                'address2'     : returnData.street_number,
                'postalCode'   : returnData.postal_code,
                'country'      : returnData.country
            }
        },

        /**
         * Extract configured types out of raw result as
         * Geocode API does not allow to do it
         * @param results
         * @returns {GeocoderResult}
         * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
         */
        filterGeocodeResultTypes (results) {

            if (!results || !this.types) {
                return results;
            }

            let output = [];
            let types  = [this.types];

            if (types.includes('(cities)')) {
                types = types.concat(CITIES_TYPE);
            }
            if (types.includes('(regions)')) {
                types = types.concat(REGIONS_TYPE);
            }

            for (let r of results) {
                for (let t of r.types) {
                    if (types.includes(t)) {
                        output.push(r);
                        break;
                    }
                }
            }

            return output;
        }
    }
});
